import type { GridSize, Point } from "./types";

/** Ekran en-boy oranına göre oyun grid'ini hesaplar (menü/oyun başlangıcı için). */
export function computeGridSize(aspect: number): GridSize {
  const cols = Math.round(aspect * 21);
  return {
    cols: Math.max(20, Math.min(38, cols)),
    rows: Math.max(15, Math.min(32, Math.round(cols / aspect))),
  };
}

/** Nokta grid dışındaysa karşı kenara sarar (modüler aritmetik). */
export function wrapPoint(p: Point, grid: GridSize): Point {
  return { x: mod(p.x, grid.cols), y: mod(p.y, grid.rows) };
}

/** Nokta grid sınırları içinde mi? */
export function isInside(p: Point, grid: GridSize): boolean {
  return p.x >= 0 && p.y >= 0 && p.x < grid.cols && p.y < grid.rows;
}

/** JS'in negatif sayılarda yanlış mod davranışını düzeltir. */
function mod(n: number, m: number): number {
  return ((n % m) + m) % m;
}
